import React from "react";
import ReactDOM from "react-dom/client";
import { Route, Routes, BrowserRouter as Router } from "react-router-dom";
import "./index.css";
import App from "./App";
import { SnackbarProvider } from "notistack";
import PollComponent from "./components/Polling";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <SnackbarProvider maxSnack={3} autoHideDuration={3000}>
    <Router>
      {" "}
      <Routes>
        <Route path="/poll-component" element={<PollComponent />} />
        <Route path="*" element={<App />} />
      </Routes>
    </Router>
  </SnackbarProvider>
);
